module.exports = __webpack_public_path__ + "static/media/calandar-on.98ab61ba.svg";